"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ravenCaptureException = exports.installRaven = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const raven_js_1 = __importDefault(require("raven-js"));
/**
 * Installs Raven with Epic's predefined configuration
 * @see https://docs.sentry.io/clients/javascript
 *
 * @param {string} sentryUrl
 * @param {object} [config={}]
 * @param {string} [config.release = root.clientEnvConfig.EPIC_IMAGE_TAG]
 * @param {string} [config.environment = root.location.host]
 * @param {string} [config.serverName = 'web-client']
 * @param {object} [config.tags = {}]
 * @param {string} [config.tags.locale = root.__locale] - client locale (en-US)
 *
 * @example
 * // server/config/ServerConfig.js
 * const mergeEnvConfig = async() => {
 *  ...
 *  serverConfig.clientEnvConfig = {
 *      ...
 *      EPIC_IMAGE_TAG: process.env.EPIC_IMAGE_TAG
 *  };
 *  ...
 * };
 *
 * import {installRaven} from '@epic-core/common';
 * const sentryUrl = 'https://e042dc845df64277a9bd6a63526a948f@sentry.io/1241729';
 * const config = {release: root.clientEnvConfig.EPIC_IMAGE_TAG}
 * installRaven(sentryUrl, config);
 */
function installRaven(sentryUrl, config = {}) {
    // auto-add release if not part of config object
    if (!config.release && window_or_global_1.default.clientEnvConfig && window_or_global_1.default.clientEnvConfig.EPIC_IMAGE_TAG) {
        config.release = window_or_global_1.default.clientEnvConfig.EPIC_IMAGE_TAG;
    }
    // auto-add environment
    config.environment = config.environment || window_or_global_1.default.location.host;
    // auto set serverName to web-client if not already set
    config.serverName = config.serverName || 'web-client';
    // attempt to add user's locale to the tags object
    config.tags = config.tags || {};
    config.tags.locale = config.tags.locale || window_or_global_1.default.__locale;
    // configure and install
    raven_js_1.default.config(sentryUrl, config).install();
}
exports.installRaven = installRaven;
function ravenCaptureException(message) {
    console.error(message);
    raven_js_1.default.captureException(message);
}
exports.ravenCaptureException = ravenCaptureException;
//# sourceMappingURL=sentry.js.map